import { BrowserUtils } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { GreyButton } from './Style'; 



import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';

export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect(    
    );
  };

  return <Button variant="contained" color="success" onClick={handleSignOut} sx={{ height: '48px' }}>Sign Out</Button>;
};
